import { useTranslation } from 'react-i18next';
import type { KnownBookingSource } from '../types/booking';

interface BookingSourceBadgeProps {
  readonly source: string; // string (not KnownBookingSource) — tolerates unknown future sources gracefully
}

// Record<KnownBookingSource, string> enforces exhaustiveness at compile time — adding a new
// KnownBookingSource value without updating these tables causes a TS error (Effective TypeScript §28).
const SOURCE_STYLES: Record<KnownBookingSource, string> = {
  DIRECT: 'bg-blue-100 text-blue-700',
  AIRBNB: 'bg-rose-100 text-rose-700',
};

const KNOWN_SOURCES = Object.keys(SOURCE_STYLES) as KnownBookingSource[];

export const BookingSourceBadge = ({ source }: BookingSourceBadgeProps) => {
  const { t } = useTranslation('badges');

  const SOURCE_LABELS: Record<KnownBookingSource, string> = {
    DIRECT: t('sourceDirect'),
    AIRBNB: t('sourceAirbnb'),
  };

  const isKnown = KNOWN_SOURCES.includes(source as KnownBookingSource);
  const classes = isKnown
    ? SOURCE_STYLES[source as KnownBookingSource]
    : 'bg-gray-100 text-gray-500';
  const label = isKnown
    ? SOURCE_LABELS[source as KnownBookingSource]
    : source;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${classes}`}>
      {label}
    </span>
  );
};
